import { TimezoneObjectType, useTimezonesLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useEffect } from 'react';

const useTimezones = (skip = false) => {
  const [query, { data, loading }] = useTimezonesLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const request = async () => {
    const timezonesData = await query();

    return timezonesData;
  };

  const timezones = data?.timezones as TimezoneObjectType[];

  useEffect(() => {
    if (!skip) request();
  }, [skip]);

  return {
    loading,
    timezones,
    request,
  };
};

export default useTimezones;
